import React, { useState } from 'react';
import AppointmentBanner from '../AppointmentBanner/AppointmentBanner';

const Appointment = () => {
    const [date, setDate] = useState(new Date());
    return (
        <div>
            <AppointmentBanner></AppointmentBanner>
        </div>
    );
};

export default Appointment;